{
  "additional_products": "Zusätzliche Produkte",
  "bikes": "Fahrräder",
  "booking_summary": "Buchungsübersicht",
  "cabins": "Kabinen",
  "date": "Datum",
  "departure": "Abfahrt",
  "local_costs": "Kosten vor Ort",
  "port_of_departure": "Abfahrtshafen",
  "ship": "Schiff",
  "tour": "Reise"
}
